export default "<h3 style=\"margin: 0 auto;\">keva tab Intiated</h3>\n";